// @flow
import React from 'react'
import styles from './styles.css'

type Props = {
  count: number,
}

const MigrationBanner = ({ count }: Props) => {
  if (count <= 0) return null
  const noun = count === 1 ? 'legacy attachment' : 'legacy attachments'
  const verb = count === 1 ? 'needs' : 'need'
  return (
    <div className={styles.migrationBanner}>
      <div className={styles.migrationBannerText}>
        <strong>{count}</strong> {noun} {verb} to be placed. Click{' '}
        <strong>Move</strong> on a queue item, choose a folder, and confirm.
      </div>
    </div>
  )
}

export default MigrationBanner
